import {
  MEMBERS_URL,
  MEMBER_URL,
  SEARCH_MEMBERS_URL,
  ACCOUNT_USERS_URL,
  ACCOUNT_USER_URL
} from 'app/utils/Constants';

import {
  post,
  put,
  patch
} from 'app/services/ApiService';
import { destroy } from './ApiService';

export const getMembers = async params => {
  return await post(SEARCH_MEMBERS_URL(), params);
}

export const createMember = async params => {
  params.portal2 = true;
  return await post(MEMBERS_URL(), params);
}

export const updateMember = async (id, params) => {
  return await put(MEMBER_URL(id), params);
}

export const destroyMembers = async ids => {
  let params = { ids };
  return await patch(MEMBERS_URL(), params);
}

export const createAccountUser = async (accountId, params) => {
  return await post(ACCOUNT_USERS_URL(accountId), params);
}

export const updateAccountUser = async (accountId, userId, params) => {
  return await put(ACCOUNT_USER_URL(accountId, userId), params);
}

export const deleteAccountUser = async (accountId, userId) => {
  return await destroy(ACCOUNT_USER_URL(accountId, userId));
}